export default function blogFilter(element) {
    let categories = element.querySelectorAll('.categories__items .categories__item');
    let items = element.querySelectorAll('.blog__items .blog__item');

    categories.forEach(category => {
        let category_id = parseInt(category.dataset.id, 10);

        category.addEventListener('click', function(event) {
            if (category.classList.contains('active')) return;

            categories.forEach(cat => cat.classList.remove('active'));
            category.classList.add('active');
        
            let isAll = category_id === 0;
            items.forEach(item => {
                const matches = parseInt(item.dataset.category_id, 10) === category_id;
                item.classList.toggle('hidden', !isAll && !matches);
            });
        });
    });
}